import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './content/layout/layout.component';
import { LayoutModule } from './content/layout/layout.module';
import { AuthGuardService as AuthGuard } from './core/services/auth-guard.service';
import { ResetPasswordComponent } from './content/pages/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: '/login', pathMatch: 'full' },
      {
        path: 'gestion-reportings',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/gestion-reportings/gestion-reportings.module#GestionReportingModule'
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/dashboard/dashboard.module#DashboardModule',
      },
      {
        path: 'conseil-direction',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/conseil-direction/conseil-direction.module#ConseilDirectionModule',
      },
      {
        path: 'mes-ofa',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/mes-ofa/mes-ofa.module#MesOfaModule',
      },
      {
        path: 'mon-databook',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/mon-databook/mon-databook.module#MonDatabookModule',
      },
      {
        path: 'liste-databook',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/liste-databook/liste-databook.module#ListeDatabookModule',
      },
      {
        path: 'aide-eia',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/aide/aide.module#AideModule',
      },
      {
        path: 'aide-ofa',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/aide/aide.module#AideModule',
      },
      {
        path: 'gestion-formations',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/gestion-formations/gestion-formations.module#GestionFormationsModule',
      },
      {
        path: 'structure',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/structure/structure.module#StructureModule',
      },
      {
        path: 'evaluation',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/evaluation/evaluation.module#EvaluationModule'
      },
      {
        path: 'campagne',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/campagne/campagne.module#CampagneModule'
      },
      {
        path: 'consultation',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/consultation/consultation.module#ConsultationModule'
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: './content/pages/settings/settings.module#SettingsModule'
      },
    ]
  },
  {
    path: 'desk',
    canActivate: [AuthGuard],
    loadChildren: './content/pages/desk/portal.module#PortalModule',
  },
  {
    path: 'lockscreen',
    canActivate: [AuthGuard],
    loadChildren: './content/pages/lockscreen/lockscreen.module#LockScreenModule',
  },
  {
    path: 'error-500',
    canActivate: [AuthGuard],
    loadChildren: './content/pages/error-500/error-500.module#Error500Module',
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: './content/pages/home/home.module#HomeModule'
  },
  {
    path: 'formations',
    canActivate: [AuthGuard],
    loadChildren: './content/pages/formations/formations.module#FormationsModule'
  },
  {
    path: 'login',
    loadChildren: './content/pages/login/login.module#LoginModule'
  },
  {
    path: 'portail-eia',
    canActivate: [AuthGuard],
    loadChildren: './content/pages/portal-eia/portal-eia.module#PortalEiaModule'
  },
  {
    path: 'portail-ofa',
    canActivate: [AuthGuard],
    loadChildren: './content/pages/portal-ofa/portal-ofa.module#PortalOfaModule'
  },
  {
    path: 'maintenance',
    loadChildren: './content/pages/error/error-404.module#Error404Module',
  },
  {
    path: '**',
    redirectTo: './content/pages/error/error-404.module#Error404Module',
  },
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    LayoutModule,
  ],
  declarations: [],
  exports: [],
})
export class AppRoutingModule { static totalRoutes: number = routes.length }
